export enum ArtifactTypeEnum {
    Suite = 'suite',
    Scenario = 'scenario',
    Feature = 'feature',
    Step = 'step'
}